import { Category, Course } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'
import {
  ConcreteCategory,
  useCategories,
} from 'components/CatalogExplorer/dataFetching'

export const useCourseCategories = () => {
  const { course } = useStaticData<{
    primaryCategory: Category
    course: Course
  }>()
  const categories = useCategories()
  const courseCats = categories.filter((cat: ConcreteCategory) =>
    course?.categoryIds?.includes(cat.id),
  )

  // this is required because we need the type Category in the useWhatBringsYouVariantPALM
  return courseCats as unknown as Category[]
}
